module.exports = __webpack_public_path__ + "static/media/bulldozer_yellow.19d39172.svg";